import NBType, { InferType } from '@netbase/nb-type'
import ActionSchema from '../dispatch/ActionSchema'
// import { QueryData } from '../../utils/queryDataUtil'

const RunSearchSchema = ActionSchema.shape('RunSearchSchema', {
  service: NBType.mixed(), // TODO: nb.dto.Service
  namesMap: NBType.mixed() // hold namesMap
  // queryData: NBType.mixed().default(() => QueryData())
})
export default RunSearchSchema

export type RunSearch = InferType<typeof RunSearchSchema>
